import { html, css } from 'lit';
import { Styles } from '../types/types';
import OlComponent from './OlComponent'

export default class FontFamilyComponent extends OlComponent {
    onClick: (value: Styles["font-family"]) => void;
    constructor(onClick: (value: Styles["font-family"]) => void) {
        super();
        this.onClick = onClick;
    }

    override styles = css`
    .ff-buttons button {
        border-radius: 20px;
        border: none;
    }
    .ff-buttons button:hover {
        box-shadow: 2px 2px 3px 2px rgba(0,0,0,.1);
        opacity: 1;
    }
`

    override render() {
        return (
            html`
            <style>${this.styles}</style>
            <div class="ff-buttons container">
                <button @click=${() => this.onClick("sans-serif")} part="button">Sans-Serif</button>
                <button @click=${() => this.onClick("serif")} part="button">Serif</button>
                <button @click=${() => this.onClick("monospace")} part="button">Monospace</button>

            </div>`
        )
    }
}